export default __webpack_public_path__ + "static/media/monikaPioro.efa00b18.jpeg";